document.querySelector('buy-buttons .button[type="submit"]').textContent = "PRE ORDER";

const products = {
    "coffee" : {
        "tusk-reserve-baobab-astronomer-coffee": "sku-baobab-coffee",
        "tusk-reserve-the-beekeeper-of-tsavo-coffee": "sku-beekeeper-coffee",
        "tusk-reserve-the-silent-train-coffee": "sku-silent-coffee",
        "tusk-reserve-complete-coffee-bundle-trio": "sku-coffee-bundle1",
    },
    "tea" : {
        "tusk-reserve-the-acacia-watch-black-tea": "sku-acacia-tea",
        "tusk-reserve-the-okavango-mist-green-tea": "sku-okavango-tea",
        "tusk-reserve-the-moonlit-baobab": "sku-moonlit-tea",
        "tusk-reserve-complete-tea-bundle-trio": "sku-tea-bundle1",
    },
    "bathtime" : {
        "tusker-scouts-adventure-suds": "sku-adventure",
        "tusker-scouts-scout-shield": "sku-scout",
        "tusker-scouts-tangle-tracker": "sku-tangle",
        "tusker-scouts-bathtime-bundle": "sku-bathtime3",
    },
    "plushies" : {
        "dr-tusk-plushie": "sku-dr",
        "philly-frank-plushie": "sku-philly",
        "rumo-plushie": "sku-rumo",
        "wingston-plushie": "sku-wingston",
        "zuli-plushie": "sku-zuli",
        "expedition-family-plushies": "sku-expedition",
    },

};

const allIngredients = {
    "Adventure-Suds": "Water (Aqua), Sodium Lauroyl Methyl Isethionate, Cocamidopropyl Betaine, Sodium Methyl Oleoyl Taurate, Coco-Glucoside, Lauryl Glucoside, Musa Sapientum (Banana) Leaf/Trunk Extract, Gluconolactone, Sodium Benzoate, Potassium Sorbate, Sodium Chloride, Glycerin, Citric Acid, Propanediol, Sodium Phytate, Artocarpus Heterophyllus (Jackfruit) Fruit Extract, Prunus Domestica (Plum) Seed Oil, Hydrolyzed Adansonia Digitata (Baobab) Seed Extract, Aloe Barbadensis Leaf Juice, Beta-Glucan, Carica Papaya (Papaya) Seed Oil, Ficus Carica (Fig) Fruit Extract, Cucumis Sativus (Cucumber) Fruit Extract, Benzyl Alcohol, Xanthan Gum.",
    "Scout-Shield": "Water (Aqua), Glycerin, Cetearyl Olivate, Glyceryl Stearate, Sorbitan Olivate, Adansonia Digitata (Baobab) Seed Oil, Butyrospermum Parkii (Shea) Butter, Mangifera Indica (Mango) Seed Butter, Musa Sapientum (Banana) Leaf/Trunk Extract, Cetearyl Alcohol, Simmondsia Chinensis (Jojoba) Seed Oil, Vitis Vinifera (Grape) Seed Oil, Gluconolactone, Sodium Stearoyl Lactylate, Acacia Senegal Gum, Potassium Sorbate, Xanthan Gum, Sodium Benzoate, Aloe Barbadensis Leaf Juice, Sodium Phytate, Ficus Carica (Fig) Fruit Extract, Artocarpus Heterophyllus (Jackfruit) Fruit Extract, Prunus Domestica (Plum) Seed Oil, Citric Acid.",
    "Tangle-Tracker": "Water (Aqua), Sorbitan Oleate Decylglucoside Crosspolymer, Propanediol, Musa Sapientum (Banana) Leaf/Trunk Extract, Caprylyl Glycol, Glyceryl Caprylate, Artocarpus Heterophyllus (Jackfruit) Fruit Extract, Lactobacillus/Arundinaria Gigantea (Bamboo) Leaf Ferment Filtrate, Sodium Phytate, Caprylhydroxamic Acid, Panthenol, Citric Acid, Glycerin, Polycitronellol, Hydrolyzed Adansonia Digitata (Baobab) Seed Extract, Adansonia Digitata (Baobab) Seed Oil, Glycyrrhiza Glabra (Licorice) Root Extract, Mangifera Indica (Mango) Seed Butter, Sclerocarya Birrea (Marula) Seed Oil, Tamarindus Indica (Tamarind) Seed Polysaccharide.",
    "Baobab-Astronomer": "100% organic arabica coffee beans",
    "The-Beekeeper-of-Tsavo": "100% organic arabica coffee beans",
    "The-Silent-Train":"100% organic arabica coffee beans",
    "The-Acacia-Watch": "Kenyan black tea, cacao husk, cinnamon bark, honey, chicory",
    "The-Okavango-Mist": "Green tea, lemongrass, wild mint, white grapefruit peel, moringa leaf, nettle",
    "The-Moonlit-Baobab": "Chamomile, lemon balm, tulsi, holy basil, lavender, rosehip, oatstraw, marshmallow root"

};

const faqItems = {
    "faq1scouts": {
        "question": "What are the Tusker Scouts?",
        "answer": "The Tusker Scouts are a group of adventurous animal characters, each with their own unique traits and missions, designed to inspire and educate children about kindness, exploration, and the natural world."
    },
    "faq2scouts": {
        "question": "What products are available in the Tusker Scouts line?",
        "answer": "The Tusker Scouts product line includes a variety of items such as plush toys, apparel, accessories, and educational materials featuring the different scout characters."
    },
    "faq3scouts": {
        "question": "Where can I purchase Tusker Scouts products?",
        "answer": "Tusker Scouts products can be purchased through our official website, select retail partners, and online marketplaces."
    },
    "faq1coffeetea": {
       "question": "Where do you source your coffee and tea?",
       "answer": "We partner directly with heritage estates and sustainable farms across high-altitude, nutrient-dense regions. Every leaf and bean is ethically harvested to ensure peak botanical complexity while actively supporting environmental stewardship."
    },
    "faq2coffeetea": {
        "question": "Are there any artificial flavorings or additives in your blends?",
        "answer": "Never. Our provisions are crafted strictly from pure, unadulterated botanicals. We rely entirely on the natural terroir of the harvest, ensuring a clean, complex cup free from synthetic flavorings, artificial preservatives, or chemical residues."
    },
    "faq3coffeetea": {
        "question": "How should I store my coffee and tea to maintain maximum freshness?",
        "answer": "To preserve the rich aromatics and natural oils, keep your botanical provisions in a cool, dark, and dry environment. We recommend sealing them tightly in an airtight container after each use to protect their full sensory profile and extend their peak freshness."
    },
};

const purposeBandSectionCopies = {
    "copy1tea": {
       "subHeading": "ROOTED IN TRADITION",
       "heading": "Inspired by Nature. <br> Steeped in Ritual.<br> <span>Pure &amp; Restorative.</span>",
        "items": {
            "Antioxidant Rich": "Carefully sourced leaves packed with natural antioxidants to fortify your system and protect against daily environmental stressors.",
            "Sustainably Harvested": "Cultivated in high-altitude, nutrient-rich soils. We partner directly with heritage estates to ensure every leaf is picked with respect for the land.",
            "Zero Artificial Additives": "Pure, unadulterated flavor. Free from synthetic flavorings and artificial preservatives, allowing the true, complex botanical notes to shine.",
            "A Restorative Ritual": "Designed to be more than just a beverage. Each cup offers a moment of quiet reflection, grounding your senses and bringing calm to your daily routine."
        }
    },
    "copy2coffee": {
        "subHeading": "ROOTED IN ELEVATION",
        "heading": "Inspired by Nature. <br> Roasted for the Ascent.<br> <span>Bold &amp; Complex.</span>",
        "items": {
            "Small-Batch Roasted": "Artisanally roasted in small batches to draw out the deep, complex flavor profiles locked within each bean, ensuring a perfect cup every time.",
            "High-Altitude Sourced": "Grown in nutrient-dense soils at peak elevations. Our beans are ethically sourced from sustainable farms that prioritize environmental stewardship.",
            "Pure & Unadulterated": "Absolutely zero artificial flavorings or synthetic additives. Just pure, robust coffee that delivers a clean, focused energy without the chemical crash.",
            "The Morning Command": "Built for the early riser. A bold, highly stimulating ritual designed to clear the mind and prep you for the day's expedition."
        }
    },
    "copy3bathtime": {
        "subHeading": "ROOTED IN WONDER",
        "heading": `Inspired by Nature. <br> Made for Little Exploreres.<br> <span>Gentle &amp; Clean.</span>`,
        "items": {
            "Tear-Free & Gentle" : "Formulated specifically for delicate eyes and sensitive skin. Our wash provides a soft, pillowy lather that cleanses without the tears, making bathtime a breeze.",
            "Plant Powered" : "Made with a premium foundation of soothing botanicals. We fortify your little scout's natural skin barrier rather than stripping it with harsh, synthetic detergents.",
            "Fragrance-Free": "Pure, clean, and completely free of artificial perfumes and synthetic fragrances. We let nature take the lead, keeping your child's routine safe and irritant-free.",
            "Scout-Approved Fun" : "We know that kids can be picky, which is why we made sure our products are not only effective but also fun to use. With playful packaging and a gentle formula, your little scout will look forward to bath time every day."
        }
    },
    "copy4plushies": {
        "subHeading": "ROOTED IN WONDER",
        "heading": `Inspired by Nature. <br> Made for Little Exploreres.<br> <span>Gentle &amp; Clean.</span>`,
        "items": {
            "Tear-Free & Gentle" : "Formulated specifically for delicate eyes and sensitive skin. Our wash provides a soft, pillowy lather that cleanses without the tears, making bathtime a breeze.",
            "Plant Powered" : "Made with a premium foundation of soothing botanicals. We fortify your little scout's natural skin barrier rather than stripping it with harsh, synthetic detergents.",
            "Fragrance-Free": "Pure, clean, and completely free of artificial perfumes and synthetic fragrances. We let nature take the lead, keeping your child's routine safe and irritant-free.",
            "Scout-Approved Fun" : "We know that kids can be picky, which is why we made sure our products are not only effective but also fun to use. With playful packaging and a gentle formula, your little scout will look forward to bath time every day."
        }
    },
}

const productInfo = {

    // COFFEE
    "sku-baobab-coffee": {
        "subHeading" : "",
        "topLabels" : [
            "Roast #1",
            "Net Wt 12 oz 340 g",
        ],
        "infoLabels" : {
            "Bean" : "Whole",
            "Roast" : "Medium-Dark",
            "Caffeine" : "Yes",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "45% Uganda, 35% Tanzania, 20% Ethiopia",
            "Tasting Notes" : "Dark Chocolate | Date | Cedar | Ember",
        },
        "ingredients" : ["Baobab-Astronomer"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy2coffee",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Stars. Baobab. First Light Watch.",
                "description" : "Inspired by the night watchmen of the old reserve, who charted constellations beneath a hollow baobab before first light. This medium-dark field roast carries dark chocolate depth, date-like sweetness, and a dry cedar finish. Crafted for the first cup of the morning.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Dark Chocolate. Date. Cedar. Ember.",
                "description" : "Smooth dark chocolate first, then dried-fruit sweetness, then a dry cedar finish with a faint ember warmth.",
            }
        }
    },
    "sku-beekeeper-coffee": {
        "subHeading" : "",
        "topLabels" : [
            "Roast #1",
            "Net Wt 12 oz 340 g",
        ],
        "infoLabels" : {
            "Bean" : "Whole",
            "Roast" : "Medium",
            "Caffeine" : "Yes",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "50% Kenya, 30% Uganda, 20% Tanzania",
            "Tasting Notes" : "Wild Honey | Black Tea | Orange Peel | Camp Smoke",
        },
        "ingredients" : ["The-Beekeeper-of-Tsavo"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy2coffee",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Bees. Smoke. Elephant Tracks.",
                "description" : "Inspired by the beekeepers of Tsavo, who tend their hives at the edge of elephant paths and read the weather in smoke before first light. This Kenya-led field roast carries wild honey aroma, black-tea structure, orange-peel brightness, and a clean camp-smoke finish..",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Wild Honey. Black Tea. Orange Peel. Camp Smoke.",
                "description" : "Warm honey aroma, black-tea structure, orange-peel brightness, and a clean smoky finish.",
            }
        }
    },
    "sku-silent-coffee": {
        "subHeading" : "",
        "topLabels" : [
            "Roast #1",
            "Net Wt 12 oz 340 g",
        ],
        "infoLabels" : {
            "Bean" : "Whole",
            "Roast" : "Medium-Dark",
            "Caffeine" : "Yes",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "40% Kenya, 35% Tanzania, 25% Uganda",
            "Tasting Notes" : "Cacao Nib | Molasses | Black Fig | Charred Oak",
        },
        "ingredients" : ["The-Silent-Train"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy2coffee",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Quiet Tracks. Empty Crates. Herds Restored.",
                "description" : "Inspired by the final train out of the old ivory trade. When the tracks fell quiet, the crates were emptied, and the herds returned. This medium-dark roast carries cacao-nib depth, molasses sweetness, black-fig richness, and a dry charred-oak finish.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Cacao Nib, Molasses, Black Fig. Charred Oak.",
                "description" : "Deep cacao, blackstrap molasses, dark fig, and a dry charred-oak finish.",
            }
        }
    },
    "sku-coffee-bundle1": {
        "subHeading" : "",
        "topLabels" : [
            "Complete Trio",
            "Net Wt 12 oz 340 g"
        ],
        "infoLabels" : {
            "Bean" : "Whole",
            "Roast" : "Medium-Dark",
            "Caffeine" : "Yes",
            "Made" : "Philadelphia, PA"
        },
        "footNotes" : {
            "Origin" : "Uganda, Ethiopia, Tanzania, Kenya",
            "Tasting Notes" : "Dark Chocolate | Date | Cedar | Ember | Wild Honey | Black Tea | Orange Peel | Camp Smoke | Cacao Nib | Molasses | Black Fig | Charred Oak"
        },
        "ingredients" : ["Baobab-Astronomer", "The-Beekeeper-of-Tsavo", "The-Silent-Train"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy2coffee",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE ROASTER'S RESERVE",
                "heading" : "Forged for the Early Ascent.",
                "description" : "Built for the early riser who commands the day. A bold, highly stimulating trio of our finest medium-dark roasts—featuring Baobab Astronomer, The Beekeeper of Tsavo, and The Silent Train. Designed to clear the mind and prep you for the expedition ahead with deep, resonant flavor profiles.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696"
            },
            "box2" : {
                "subHeading": "THE CRAFT",
                "heading" : "High-Altitude Artisan Roasts.",
                "description" : "Grown in nutrient-dense soils at peak elevations across Uganda, Tanzania, and Ethiopia. Artisanally roasted in small batches in Philadelphia, these beans draw out dark chocolate and cedar notes to deliver a clean, focused energy and a robust cup free from the chemical crash."
            }
        }
    },

    // TEA

    "sku-acacia-tea": {
        "subHeading" : "",
        "topLabels" : [
            "Net Wt 1.32 oz • 37.5 g",
            "15 Pyramid Sachets",
        ],
        "infoLabels" : {
            "Blend" : "Whole-Leaf",
            "Type" : "Black",
            "Caffeine" : "High",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "Kenya",
            "Tasting Notes" : "Black Tea | Cacao Husk | Dry Honey | Cinnamon Bark",
        },
        "ingredients" : ["The-Acacia-Watch"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy1tea",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Morning Tea. First Light.",
                "description" : "Inspired by acacia shade, early light, and the quiet discipline of the reserve before the heat rises, The Acacia Watch is built on bold Kenyan black tea with cacao husk depth, dry honey warmth, and a restrained cinnamon-bark finish.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Black Tea. Cacao Husk. Dry Honey. Cinnamon Bark.",
                "description" : "A bold field infusion for first light, steady focus, and the daily watch.",
            }
        }
    },
    "sku-okavango-tea": {
        "subHeading" : "",
        "topLabels" : [
            "Net Wt 1.32 oz • 37.5 g",
            "15 Pyramid Sachets",
        ],
        "infoLabels" : {
            "Blend" : "Whole-Leaf + Botanicals",
            "Type" : "Green",
            "Caffeine" : "Light",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "East Africa, Southeast Asia",
            "Tasting Notes" : "Green Tea | Lemongrass | Wild Mint | White Grapefruit",
        },
        "ingredients" : ["The-Okavango-Mist"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy1tea",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Midday. Clean. Botanical. Atmospheric.",
                "description" : "Inspired by mist over the Okavango, where reeds bend, water paths shift, and elephants move quietly before the heat rises, The Okavango Mist blends green tea with lemongrass, wild mint, and white grapefruit for a clean, lightly caffeinated botanical cup.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Green Tea. Lemongrass. Wild Mint. White Grapefruit",
                "description" : "Smooth green tea, cool herbs, soft citrus, and a dry refreshing finish.",
            }
        }
    },
    "sku-moonlit-tea": {
        "subHeading" : "",
        "topLabels" : [
            "Net Wt 1.32 oz • 37.5 g",
            "15 Pyramid Sachets",
        ],
        "infoLabels" : {
            "Blend" : "Whole-Leaf + Flowers + Dried Fruit",
            "Type" : "Herbal",
            "Caffeine" : "None",
            "Made" : "Philadelphia, PA",
        },
        "footNotes" : {
            "Origin" : "East Africa, Southeast Asia",
            "Tasting Notes" : "Chamomile | Lemon Balm | Tulsi | Lavender",
        },
        "ingredients" : ["The-Moonlit-Baobab"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy1tea",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "ATMOSPHERE",
                "heading" : "Evening. Restorative. Silence.",
                "description" : "Inspired by the reserve after dusk, when the baobab holds the last warmth of the day and the field settles beneath the moon, The Moonlit Baobab blends chamomile, lemon balm, tulsi, and restrained lavender for a soft caffeine-free botanical cup.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696",
            },
            "box2" : {
                "subHeading": "CUP PROFILE",
                "heading" : "Chamomile. Lemon Balm. Tulsi. Lavender.",
                "description" : "Golden chamomile, lemon balm softness, tulsi warmth, and a quiet lavender finish.",
            }
        }
    },
    "sku-tea-bundle1": {
        "subHeading" : "",
        "topLabels" : [
            "Net Wt 3.96 oz • 112.5 g",
            "45 Pyramid Sachets"
        ],
        "infoLabels" : {
            "Blend" : "Whole-Leaf + Flowers + Dried Fruit",
            "Type" : "Herbal",
            "Caffeine" : "None",
            "Made" : "Philadelphia, PA"
        },
        "footNotes" : {
            "Origin" : "East Africa, Southeast Asia",
            "Tasting Notes" : "Dark Chocolate | Date | Cedar | Ember | Green Tea | Lemongrass | Wild Mint | White Grapefruit | Chamomile | Lemon Balm | Tulsi | Lavender"
        },
        "ingredients" : ["The-Acacia-Watch", "The-Okavango-Mist", "The-Moonlit-Baobab"],
        "faqs" : ["faq1coffeetea", "faq2coffeetea", "faq3coffeetea"],
        "purposeBandSecCopy": "copy1tea",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE HERBAL RESERVE",
                "heading" : "A Restorative Botanical Expedition.",
                "description" : "Experience the quiet calm of the African landscape. This curated trio of whole-leaf herbal provisions—featuring The Acacia Watch, The Okavango Mist, and The Moonlit Baobab—bridges the gap between ancient botanical rituals and modern restoration. A completely caffeine-free retreat to ground your daily rhythm.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696"
            },
            "box2" : {
                "subHeading": "THE CRAFT",
                "heading" : "Whole-Leaf Heritage Sourcing.",
                "description" : "Cultivated in nutrient-rich soils and ethically harvested by heritage estates. Every pyramid sachet is packed with pure, unadulterated flowers, leaves, and dried fruit to deliver a complex, grounding cup completely free of synthetic flavorings or artificial additives."
            }
        }
    },
    // BATH TIME AND PLUSHIES

    "sku-adventure" : {
        "subHeading" : "Hair & Body Wash",
        "topLabels" : [
            "Age Range: Kids 2+",
            "NET WT. 12 oz • 355 mL"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "100% Fragrance Free": "",
            "Use": "hair, body, daily bath time and post-play cleanup",
            "Botanicals": "Banana Leaf & Trunk | Jackfruit | Baobab | Aloe Leaf | Papaya | Fig | Cucumber",
        },
        "ingredients" : ["Adventure-Suds"],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy3bathtime",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "PURPOSE",
                "heading" : "Wash Away the Trail Dust.",
                "description" : "A gentle, tear-free, fragrance-free wash formulated for the most sensitive little scouts. Naturally derived cleansers effortlessly wash away camp mud, trail dust, and daily grime without stripping delicate skin.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "BOTANICALS",
                "heading" : "Botanicals From the Elephant Trail.",
                "description" : "Inspired by the fruits, leaves, and botanicals elephants encounter along the trail, this wash features banana leaf/trunk extract, jackfruit, baobab, and aloe to help wash away the day while leaving skin and hair feeling soft and fresh."
            }
        }
    },

    "sku-scout" : {
        "subHeading" : "Daily Moisture Lotion",
        "topLabels" : [
            "Age Range: Kids 2+",
            "NET WT. 12 oz • 355 mL"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "100% Fragrance Free": "",
            "Use": "Post-bath moisture, dry-feeling skin, daily body care and bedtime routines",
            "Botanicals": "Baobab | Shea | Mango | Banana Leaf & Trunk | Jojoba | Aloe Leaf | Fig | Jackfruit | Acacia",
        },
        "ingredients" : ["Scout-Shield"],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy3bathtime",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "PURPOSE",
                "heading" : "Protect Your Child's Skin.",
                "description" : "Lock in deep, soothing hydration after a long day of exploring. This fragrance-free, botanical lotion acts as a gentle Scout Shield, fortifying your little one's natural skin barrier to keep them soft, safe, and ready for tomorrow's adventure.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "BOTANICALS",
                "heading" : "Botanicals From the Elephant Trail.",
                "description" : "Inspired by the fruits, trees, seeds, and botanicals elephants encounter along the trail, this daily lotion blends baobab seed oil, shea butter, mango seed butter, and banana leaf/trunk extract for a comforting post-bath moisture ritual."
            }
        }
    },

    "sku-tangle" : {
        "subHeading" : "Hair Detangling Spray",
        "topLabels" : [
            "Age Range: Kids 2+",
            "NET WT. 10 oz • 295 mL"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "100% Fragrance Free": "",
            "Use": "Post-bath combing, morning bedhead, curls, waves, fine hair and pool-day knots",
            "Botanicals": "Banana Leaf + Trunk | Jackfruit | Bamboo Leaf | Baobab | Marula | Mango | Tamarind | Licorice",
        },
        "ingredients" : ["Tangle-Tracker"],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy3bathtime",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "PURPOSE",
                "heading" : "Track Down Tangles Before They Become Trouble.",
                "description" : "Made for bath-time combing, morning bedhead, post-swim knots, and everyday brush-time drama, Tangle Tracker helps soften hair, smooth tangles, and make comb-through easier. This lightweight leave-in mist features banana leaf/trunk extract, jackfruit, bamboo leaf ferment, and panthenol for soft, touchable hair without a heavy feel.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "BOTANICALS",
                "heading" : "Botanicals From the Elephant Trail.",
                "description" : "Inspired by the fruits, leaves, seeds, and botanicals elephants encounter along the trail, this lightweight mist blends banana leaf/trunk extract, jackfruit, bamboo leaf ferment, baobab, and marula oil for soft, touchable hair."
            }
        }
    },

    "sku-bathtime3" : {
        "subHeading" : "Hair + Body Wash, Daily Moisture Lotion & Hair Detangler Spray",
        "topLabels" : [
            "Age Range: Kids 2+",
            "NET WT. 34 oz • 1005 mL"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "100% Fragrance Free": "",
            "Use": "Complete daily bath time and post-play cleanup, comforting dry-feeling skin during bedtime routines, and making comb-through easier for morning bedhead, curls, or pool-day tangles",
            "Botanicals": "Banana Leaf & Trunk | Jackfruit | Baobab | Aloe Leaf | Papaya | Fig | Cucumber | Shea Butter | Mango | Jojoba | Acacia | Bamboo Leaf | Marula | Tamarind | Licorice",
        },
        "ingredients" : ["Adventure-Suds", "Scout-Shield", "Tangle-Tracker"],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy3bathtime",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "PURPOSE",
                "heading" : "The Complete Tusker Scouts Bath Ritual.",
                "description" : "Send your little explorer into tomorrow’s mission soft, fresh, and ready. Step one utilizes Adventure Suds to wash hair and body. Step two uses Scout Shield to moisturize skin after the bath. Step three relies on Tangle Tracker to mist onto damp or dry hair, then comb through knots, tangles, curls, waves, and bedhead.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "BOTANICALS",
                "heading" : "Botanicals From the Elephant Trail.",
                "description" : "Inspired by the fruits, leaves, trees, seeds, and botanicals elephants encounter along the trail, this complete bath collection brings the Tusker Scouts world into the bath with plant-based ingredients like baobab, banana leaf, and jackfruit."
            }
        }
    },

    "sku-dr":{
        "subHeading" : "",
        "topLabels" : [
            "Founder & Field Guide",
            "Ages 3+"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Founder Division",
            "Species" : "African Savanna Elephant (Loxodonta africana)",
            "Mission" : "Kindness is the First Thing we Pack"
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE FOUNDER",
                "heading" : "Kindness is the First Thing We Pack.",
                "description" : "Meet Dr. Tusk, the gentle founder of the Tusker Scouts. Soft, wise, and full of storybook charm, Dr. Tusk helps little adventurers discover courage, kindness, and curiosity through everyday moments. From bath time to bedtime and every trail in between.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "A Storybook Companion for Brave Explorers.",
                "description" : "A premium seated elephant plush with a warm stone-grey body, large soft ears, and a signature curved trunk. Dressed in a soft khaki field vest featuring a founder badge and a tiny field journal pocket, he is a huggable guide ready for the trail ahead."
            }
        }
    },

    "sku-philly":{
        "subHeading" : "",
        "topLabels" : [
            "Survival Scout",
            "Ages 3+"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Shell & Survival Division",
            "Species" : "Read-Eared Slider Turtle (Trachemys scripta elegans)",
            "Mission" : "Prepared Heart. Kind Spirit."
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE SURVIVAL SCOUT",
                "heading" : "Steady Nerve. Strong Shell.",
                "description" : "Philly Frank is the Tusker Scouts’ scrappy red-eared slider from Philadelphia—a lovable survivor with steady nerve, a strong shell, and a surprising burst of speed when it counts. He teaches young Scouts about resilience, courage, and finding a new home.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "A Scrappy, Lovable Underdog.",
                "description" : "A soft olive-green plush body with a warm cream belly, clear red ear markings, and a slightly oversized shell segmented with warm golden stitching. Complete with a small safari neckerchief and mini field satchel, Frank is a huggable friend who is proud to be here."
            }
        }
    },

    "sku-rumo":{
        "subHeading" : "",
        "topLabels" : [
            "Trail Keeper",
            "Ages 3+"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Trail Keeper Division",
            "Species" : "Black Rhinoceros (Diceros bicornis)",
            "Mission" : "Slow can be brave. Small clues matter."
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE TRAIL KEEPER",
                "heading" : "Every Trail Tells a Story.",
                "description" : "Rumo is the gentle rhino Trail Keeper of the Tusker Scouts. Big, soft, and quietly brave, he carries the Trail Log and records every clue, reminding every Scout that courage can be careful and no one is ever left behind.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "Soft Strength & Quiet Comfort.",
                "description" : "A warm stone-gray rhino with a broad plush muzzle, rounded friendly horn, and a calm asymmetrical smile. He wears a simple olive field vest with a Trail Keeper badge and holds a warm brown plush Trail Log, ready to remember the way."
            }
        }
    },

"sku-wingston":{
        "subHeading" : "",
        "topLabels" : [
            "Buzz Guardian",
            "Ages 3+"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Buzz Guardian Division",
            "Species" : "Honey Bee (Apis mellifera scutellata)",
            "Mission" : "Small Guide. Mighty Heart. Pollination Pathways."
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE BUZZ GUARDIAN",
                "heading" : "Adventure Ahead.",
                "description" : "Wingston is Dr. Tusk's sky guide, co-explorer, and the bravest bug in the bush. This bold little bee navigates by scent, sun, and stars, buzzing with positive energy to show little scouts that even the smallest friends can make the biggest difference.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "A Tiny Friend with Mighty Purpose.",
                "description" : "Wearing a tiny scout hat and a satchel, Wingston is a premium, huggable companion. He is an ever-present sky guide designed to remind young explorers to protect our delicate ecosystems and always look out for the little things."
            }
        }
    },

    "sku-zuli":{
        "subHeading" : "",
        "topLabels" : [
            "Pathfinder Scout",
            "Ages 3+"
        ],
        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Pathfinder Division",
            "Species" : "Meerkat (Suricata suricatta)",
            "Mission" : "Quiet Paws. Sharp Eyes"
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE PATHFINDER",
                "heading" : "Quiet Paws. Sharp Eyes. Always on the Path.",
                "description" : "Zuli is the Tusker Scouts’ sharp-eyed Pathfinder. With quiet paws, a trusty compass, and a field journal full of clues, she finds the trail everyone else missed, teaching little Scouts that careful observation is a form of bravery.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "Alert, Capable, and Kind.",
                "description" : "A warm tan upright meerkat with soft dark eye markings, a tapered curved tail, and a tiny clever asymmetrical smile. She wears an olive scout vest with an oversized soft headlamp and small compass detail, making her the perfect clue-finding companion."
            }
        }
    },

    "sku-expedition":{
        "subHeading" : "",
        "topLabels" : [
            "Tusker Scouts",
            "Ages 3+"
        ],

        "infoLabels" : [],
        "footNotes" : {
            "Division" : "Kindness is the first thing we pack",
            "Species" : " African Savanna Elephant (Loxodonta africana), Read-Eared Slider Turtle (Trachemys scripta elegans), Black Rhinoceros (Diceros bicornis), Honey Bee (Apis mellifera scutellata), Meerkat (Suricata suricatta)",
            "Mission" : "Steady Nerve. Strong Shell."
        },
        "ingredients" : [],
        "faqs" : ["faq1scouts", "faq2scouts", "faq3scouts"],
        "purposeBandSecCopy": "copy4plushies",
        "dtSecCopy": {
            "box1" : {
                "subHeading": "THE COMPLETE FIELD TEAM",
                "heading" : "Collect the whole Tusker Scouts expedition.",
                "description" : "Dr. Tusk leads. Zuli finds. Wingston encourages. Rumo remembers. Bring the entire Tusker Scouts character world home, transforming everyday care into rituals of bravery, kindness, curiosity, and imagination.",
                "imageUrl" : "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Scouts_badge_1_no_bg.webp?v=1781643984"
            },
            "box2" : {
                "subHeading": "THE DETAILS",
                "heading" : "A Premium Character World.",
                "description" : "This complete set provides the ultimate story-rich plush collection. With distinct roles, custom scout vests, and premium details like field journals and compasses, these companions make bath time, bedtime, and every little adventure part of the Trail Log."
            }
        }
    }
};

const currentUrl = window.location.href;

Object.entries(products).forEach(([category, object]) => {

    Object.entries(object).forEach(([slug, sku]) => {

        if (currentUrl.includes(`products/${slug}`)) {

            document.querySelector(".product-gallery-card.dt-fcard").classList.add(sku);
            document.body.classList.add(sku);

            handleSelectorVisibility(category, sku);
            updateProductCardContent(sku);
            updateIngredients(sku);
            updatePurposeBandContent(sku);
            updateDtSecContent(sku)
        }
    });
});

function updateProductCardContent(sku){
    let infoLabelsHtml;
    let footNotesHtml;

    document.querySelector(".dt-fcard-content .subhead").textContent = productInfo[sku].subHeading;
    document.querySelector(".dt-fcard-kicker").innerHTML = productInfo[sku].topLabels
        .map(label => `<span>${label}</span>`)
        .join("");

    const infoLabels = productInfo[sku].infoLabels;
    if (infoLabels && Object.keys(infoLabels).length > 0) {
        infoLabelsHtml = `<div class="dt-fcard-info">`;

        Object.entries(infoLabels).forEach(([label, value]) => {

            infoLabelsHtml += `
            <p>
                <strong>${label}:</strong>
                <span>${value}</span>
            </p>`;
        });

        infoLabelsHtml += `</div>`;
    }

    const footNotes = productInfo[sku].footNotes;
    if (footNotes && Object.keys(footNotes).length > 0) {
        footNotesHtml = `<div class="dt-fcard-info m-0">`;

        Object.entries(footNotes).forEach(([label, value]) => {

            if(label == "Tasting Notes"){
                document.querySelector(".scent-info-bar span:first-child").textContent = label + ":";
                document.querySelector(".scent-info-bar span:last-child").textContent = value;
            }
            if(label == "Division"){
                document.querySelector(".scent-info-bar span:first-child").textContent = label + ":";
                document.querySelector(".scent-info-bar span:last-child").textContent = value;
            }
            if(label == "100% Fragrance Free"){
                document.querySelector(".scent-info-bar span:first-child").textContent = label;
            }

            footNotesHtml += `
            <p>
                <strong>${label}:</strong>
                <span>${value.replace(/\(([^)]+)\)/g, '<i>$1</i>')}</span>
            </p>`;
        });

        footNotesHtml += `</div>`;
    }

    document.querySelector(".dt-fcard-desc").insertAdjacentHTML("afterend", (infoLabelsHtml || "") + (footNotesHtml || ""));
}

function updateIngredients(sku) {

    let accordianWrapper = document.querySelector('.tech-accordion');

    let faqHtml = Object.values(productInfo[sku].faqs || {})
        .map((title) => faqItems[title])
        .filter(Boolean)
        .map((item) => `
        <details class="dt-faq-item">
            <summary>
                <span>${item.question}</span>
                <i></i>
            </summary>

            <div class="dt-faq-content">
                <p>${item.answer}</p>
            </div>
        </details>
    `)
        .join("");

    
    let IngredientsInfo = '';
    Object.entries(productInfo[sku].ingredients).forEach(([key, title]) => {
        IngredientsInfo += `<strong>${title.replaceAll('-',' ')}</strong> ${allIngredients[title]}<br><br>`;
    });

    if(IngredientsInfo !== ''){
        faqHtml +=
        `<details class="dt-faq-item">
            <summary>
                <span>Ingredients</span>
                <i></i>
            </summary>
            <div class="dt-faq-content">
                <p>
                   ${IngredientsInfo}
                </p>
            </div>
        </details>`;
    }

    accordianWrapper.innerHTML = faqHtml;
}

function updatePurposeBandContent(sku){

    let copyKey = (productInfo[sku].purposeBandSecCopy) ? productInfo[sku].purposeBandSecCopy : 'copy1'; 
    const copy = purposeBandSectionCopies[copyKey];
    const icons = ["✺", "✾", "◎", "♢"]; 

    document.querySelector(".dt-purpose-band-intro p").textContent = copy.subHeading;
    document.querySelector(".dt-purpose-band-intro h2").innerHTML = copy.heading;

    const purposeBandItemsHtml = Object.entries(copy.items)
        .map(([title, description]) => `
            <div class="dt-purpose-band-item">
                <div class="dt-purpose-band-icon">
                    ${icons[Object.keys(copy.items).indexOf(title) % icons.length]}
                </div>

                <h3>${title}</h3>
                <p>${description}</p>
            </div>
        `)
        .join("");
    document.querySelector(".dt-purpose-band-intro").insertAdjacentHTML("afterend", purposeBandItemsHtml);
}

function updateDtSecContent(sku){

    let box1Copy = productInfo[sku].dtSecCopy.box1;
    let box2Copy = productInfo[sku].dtSecCopy.box2;

    document.querySelector(".dt-soap-note-card.scent-mood p.dt-note-kicker").textContent = box1Copy.subHeading;
    document.querySelector(".dt-soap-note-card.scent-mood h3").textContent = box1Copy.heading;
    document.querySelector(".dt-soap-note-card.scent-mood p.description").textContent = box1Copy.description;
    document.querySelector(".dt-soap-note-illustration img").setAttribute("src", box1Copy.imageUrl);

    document.querySelector(".dt-soap-note-card.boxTwo p.dt-note-kicker").textContent = box2Copy.subHeading;
    document.querySelector(".dt-soap-note-card.boxTwo h3").textContent = box2Copy.heading;
    document.querySelector(".dt-soap-note-card.boxTwo p.description").textContent = box2Copy.description;
}

function handleSelectorVisibility(category, sku){

    const categoryConfig = {
        coffee: {
            buttonId: "coffee",
            tabId: "coffeeTab",
            selector: ".soap-selector.coffeeAndTea",
            dtSecImageClass: ".coffeeNTea",
        },
        tea: {
            buttonId: "tea",
            tabId: "teaTab",
            selector: ".soap-selector.coffeeAndTea",
            dtSecImageClass: ".coffeeNTea",
        },
        bathtime: {
            buttonId: "bathtime",
            tabId: "bathtimeTab",
            selector: ".soap-selector.bathtimeAndPlushies",
            dtSecImageClass: ".scoutsAndPlushies",
        },
        plushies: {
            buttonId: "plushies",
            tabId: "plushieTab",
            selector: ".soap-selector.bathtimeAndPlushies",
            dtSecImageClass: ".scoutsAndPlushies",
        }
    };

    const config = categoryConfig[category];

    document.getElementById(config.buttonId)?.classList.add("active");
    document.getElementById(config.tabId)?.classList.add("active");
    document.querySelector(config.selector).style.display = "block";
    document.querySelector(config.dtSecImageClass).style.display = "block";

    document.querySelectorAll(".soap-content.active .soap-item").forEach((item) => {
        item.classList.toggle("active", item.dataset.title === sku);
    });
}